<template>
  <GenericInput
    v-bind="{ ...$props, ...$attrs }"
    :value="modelValue"
    type="text"
    :readonly="loading"
    @blur="$emit('validate', modelValue)"
    @keyup="handleKeyUp"
    @update:modelValue="$emit('update:modelValue', $event)"
  >
    <template v-if="loading" v-slot:loader>
      <v-progress-linear
        class="mt[6px]"
        :active="true"
        :color="colors.primary20"
        height="5"
        indeterminate
      ></v-progress-linear>
    </template>
    <template #append-inner>
      <SearchIcon @click="handleIconClick" class="cursor-pointer hover:scale-125" />
    </template>
  </GenericInput>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import SearchIcon from '@/assets/icons/search.vue'
import GenericInput from '@/components/designSystem/Inputs/GenericInput.vue'
import { getColorVariable } from '@/utils/tailwindcss'
import { onMounted } from 'vue'

export default defineComponent({
  extends: GenericInput,
  inheritAttrs: false,
  emits: ['update:modelValue', 'validate', 'onSearch', 'search-click'],
  components: {
    GenericInput,
    SearchIcon
  },
  props: {
    searchFunction: {
      type: Function,
      default: () => {
        return function () {}
      }
    },
    debounceActived: {
      default: true
    }
    // name: {
    //   type: String,
    //   default: `search_${Math.random()}`
    // }
  },
  setup(props, ctx) {
    const visible = ref(false)
    const colors = {
      primary20: getColorVariable('primary20')?.default ?? '#3CA2B9'
    }
    const typingTimer = ref()
    const loading = ref(true)

    const onKeyUpSearch = () => {
      clearTimeout(typingTimer.value)

      typingTimer.value = setTimeout(async () => {
        try {
          loading.value = true
          await props.searchFunction()
        } catch (e) {
          console.error(e)
        } finally {
          loading.value = false
        }
      }, 500)
    }

    const executeDebounceSearch = () => {
      if (props.debounceActived) {
        onKeyUpSearch()
      }
    }

    const handleKeyUp = () => {
      ctx.emit('validate', props.modelValue)
      executeDebounceSearch()
    }

    onMounted(() => {
      executeDebounceSearch()
    })

    const handleIconClick = () => {
      ctx.emit('search-click')
    }

    return {
      visible,
      colors,
      handleKeyUp,
      loading,
      handleIconClick
    }
  }
})
</script>
